export const practiceBaseRouter = [
    {
        path: '',
        redirect: 'notice'
    },
    {
        path: 'index',
        meta: {
            title: '数据统计',
        },
        component: () => import('../views/practiceBase/page/index'),
    },
    {
        path: 'info',
        meta: {
            title: '机构信息',
        },
        component: () => import('../views/practiceBase/page/info'),
    },
    {
        path: 'desc',
        meta: {
            title: '机构介绍',
        },
        component: () => import('../views/practiceBase/page/desc'),
    },
    {
        path: 'notice',
        meta: {
            title: '通知列表',
        },
        component: () => import('../views/practiceBase/page/notice'),
    },
    {
        path: 'noticeDetail',
        meta: {
            title: '通知详情',
        },
        component: () => import('../views/practiceBase/page/noticeDetail'),
    },
    {
        path: 'account',
        meta: {
            title: '帐号管理',
        },
        component: () => import('../views/practiceBase/page/account'),
    },
    {
        path: 'organization',
        meta: {
            title: '机构信息',
        },
        component: () => import('../views/practiceBase/page/organization'),
    },
    {
        path: 'userInfo',
        meta: {
            title: '个人中心',
        },
        component: () => import('../views/practiceBase/page/userInfo'),
    },
    {
        path: 'practiceBaseList',
        meta: {
            title: '实习岗位管理',
        },
        component: () => import('../views/practiceBase/page/practiceBaseList'),
    },
    {
        path: 'practiceBaseEdit',
        meta: {
            title: '实习岗位编辑',
        },
        component: () => import('../views/practiceBase/page/practiceBaseEdit'),
    },
    {
        path: 'volunteer',
        meta: {
            title: '志愿管理',
        },
        component: () => import('../views/practiceBase/page/volunteer'),
    },
    {
        path: 'volunteerDetail',
        meta: {
            title: '志愿详情',
        },
        component: () => import('../views/practiceBase/page/volunteerDetail'),
    },
    {
        path: 'student',
        meta: {
            title: '实习生管理',
        },
        component: () => import('../views/practiceBase/page/student'),
    }, {
        path: 'studentDetail',
        meta: {
            title: '实习生详情',
        },
        component: () => import('../views/practiceBase/page/studentDetail'),
    },
    {
        path: 'recruit',
        meta: {
            title: '招聘管理',
        },
        component: () => import('../views/practiceBase/page/recruit'),
    },


]